import { sortBy, uniq } from "lodash";
import React, { ComponentProps } from "react";

import { parseObjectiveScope } from "@examspark/common";

import { useQueriesGetObjectiveScopePaths } from "../../api/operations/objectives";

import FacetCheckboxFilter from "./FacetCheckboxFilter";

const FilterObjectiveScope = (
  props: ComponentProps<typeof FacetCheckboxFilter>,
) => {
  const scopes = uniq([
    ...props.options.map((o) => o.value),
    ...props.selected,
  ]);

  const queries = useQueriesGetObjectiveScopePaths(scopes);

  const overrides = Object.fromEntries(
    queries.map((q) => {
      if (q.sectionQuery.data?.sk == null) return [];
      const scope = q.sectionQuery.data?.sk.replace("section#", "");
      const parsed = parseObjectiveScope(scope);
      const sectionLabel = q?.sectionQuery.data?.content;
      const documentLabel = parsed.documentId.split(":")[0].toUpperCase();
      return [
        q.sectionQuery.data?.sk.replace("section#", ""),
        `${documentLabel}: ${sectionLabel}`,
        // show sequence for sort debugging
        // `${documentLabel}: ${sectionLabel} ${q.sectionQuery.data.sequence}`,
      ];
    }),
  );

  // attach some `meta` to the options so we can do a sort by sequence
  const options = props.options.map((o) => {
    const sequence = queries.find((q) => {
      return q.sectionQuery.data?.sk === `section#${o.value}`;
    });

    return {
      ...o,
      meta: {
        document: sequence?.documentQuery.data?.sk,
        sequence: sequence?.sectionQuery.data?.sequence,
      },
    };
  });

  return (
    <FacetCheckboxFilter
      {...props}
      options={options}
      labelOverrides={overrides}
      sortFn={(options) => {
        return sortBy(options, ["meta.document", "meta.sequence"]);
      }}
    />
  );
};

export default FilterObjectiveScope;
